import React, { useState } from "react";
import { Drawer } from "vaul";
import { HiChevronDown, HiFolder } from "react-icons/hi";

interface BreadcrumbNode {
  folderId: string;
  folderName: string;
}

interface BreadcrumbDrawerProps {
  items: BreadcrumbNode[];
  onItemClick: (item: BreadcrumbNode) => void;
  targetElement: React.ReactNode;
}

export default function BreadcrumbDrawer({ items, onItemClick, targetElement }: BreadcrumbDrawerProps) {
  const [isOpen, setIsOpen] = useState(false);

  const renderContent = () => {
    return (
      <div className="flex flex-col py-2">
        {items.map((item, index) => (
          <React.Fragment key={index + item.folderName + "breadcrumbNode"}>
            <div
              className="flex flex-row justify-start items-center p-2 px-4 gap-3 dark:hover:bg-dark-900 hover:bg-grey-200 cursor-pointer rounded-lg mx-1"
              onClick={() => {
                setIsOpen(false);
                onItemClick(item);
              }}
            >
              <HiFolder className="flex w-4 h-4 text-grey-500" />
              <div className="text-md">{item.folderName}</div>
            </div>
            {index < items.length - 1 && (
              <div className="border-b border-grey-800 mx-3 my-1" />
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <Drawer.Root open={isOpen} onOpenChange={(open) => setIsOpen(open)}>
      <Drawer.Trigger>{targetElement}</Drawer.Trigger>
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 bg-black/40 bottom-drawer-overlay" />
        <Drawer.Content className="dark:bg-grey-900 bg-white flex flex-col rounded-t-[10px] mt-24 h-fit fixed bottom-0 left-0 right-0 outline-none bottom-drawer-content">
          <div aria-hidden className="mb-3" />
          <Drawer.Handle />
          <Drawer.Title />
          <Drawer.Description />
          <Drawer.Close />
          <div className="p-2 pt-0">{renderContent()}</div>
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
} 